/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OperatorCreate } from '../models/OperatorCreate';
import type { OperatorDetails } from '../models/OperatorDetails';
import type { OperatorUpdateDTO } from '../models/OperatorUpdateDTO';
import { request as __request } from '../core/request';

export class OperatorsVService {

    /**
     * @param operatorCode
     * @returns OperatorDetails OK
     * @throws ApiError
     */
    public static async operatorsVGetAll(
        operatorCode?: string,
    ): Promise<Array<OperatorDetails>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/operators`,
            query: {
                'operatorCode': operatorCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns OperatorDetails Created
     * @throws ApiError
     */
    public static async operatorsVCreate(
        requestBody?: OperatorCreate,
    ): Promise<OperatorDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v1/operators`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @returns OperatorDetails OK
     * @throws ApiError
     */
    public static async operatorsVGetById(
        operatorId: string,
    ): Promise<OperatorDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v1/operators/${operatorId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param requestBody
     * @returns OperatorDetails OK
     * @throws ApiError
     */
    public static async operatorsVUpdate(
        operatorId: string,
        requestBody?: OperatorUpdateDTO,
    ): Promise<OperatorDetails> {
        const result = await __request({
            method: 'PUT',
            path: `/api/v1/operators/${operatorId}`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @returns any No Content
     * @throws ApiError
     */
    public static async operatorsVDelete(
        operatorId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v1/operators/${operatorId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}